// extracted by mini-css-extract-plugin
export default {"container":"DocumentsWebPage_container__Kh+M9"};